import minervaForm from 'minerva-form';

$(function () {
});



// WEBPACK FOOTER //
// client/application/bundle.js